<template>
  <ClaimsNew
    :is-mobile="isMobile"
    :saving="claimSaving || claimFilesSaving"
    :submitted="submitted"
    :leases="activeLeases"
    :claim-types="
      Object.values($Constants.CLAIM_TYPES).filter(
        (type) => type.value !== 'fuel/electricity'
      )
    "
    :lease-id="payload.leaseId"
    :amount="payload.amountTotal"
    :claim-type="payload.claimType"
    :account-ending-in="accountEndingIn"
    :files="files"
    :errors="$v"
    :images="images"
    :entity="user.entity"
    :file-requirements="fileRequirements"
    :bank-details-error="bankDetailsError"
    @select:lease="payload = { ...payload, leaseId: $event }"
    @select:claim-type="payload = { ...payload, claimType: $event }"
    @update:amount="payload = { ...payload, amountTotal: $event }"
    @update:files="updateFiles"
    @open:bank-details="openBankDetails"
    @close="close"
    @restart="restart"
    @submit="submit"
  />
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import validations from './validations';
import { getAsset } from 'ecx.saigon.ui.common';
import PayToDialog from '@/components/organism/pay-to-dialog';

const CREATE_BASE_PAYLOAD = {
  leaseId: undefined,
  amountTotal: undefined,
  claimType: undefined,
  accountName: undefined,
  bsb: undefined,
  accountNumber: undefined
};

export default {
  name: 'ClaimsNewWidget',
  validations,
  data() {
    return {
      images: {},
      files: [],
      fileRequirements: this.$Constants.CLAIM_FILE_REQUIREMENTS,
      submitted: false,
      payload: { ...CREATE_BASE_PAYLOAD },
      bankDetailsError: ''
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      hasLeases: (state) => state.lease.hasLeases,
      leases: (state) => state.lease.leases,
      claimSaving: (state) => state.claim.claimSaving,
      claimFilesSaving: (state) => state.claim.claimFilesSaving
    }),
    ...mapGetters('lease', ['activeLeases']),
    isMobile() {
      return this.$q.screen.xs;
    },
    accountEndingIn() {
      if (!this.payload.accountNumber) {
        return;
      }

      return this.payload.accountNumber
        ? this.payload.accountNumber.toString().replace(/\W/g, '').substr(-4)
        : undefined;
    }
  },
  methods: {
    ...mapActions('claim', ['createClaim', 'saveClaimFiles']),
    updateFiles(files) {
      this.files = files;
    },
    openBankDetails() {
      const { accountName, bsb, accountNumber } = this.payload;
      this.$q
        .dialog({
          fullScreen: this.isMobile,
          initialData: { accountName, bsb, accountNumber },
          component: PayToDialog
        })
        .onOk(async (payToData) => {
          this.payload = { ...this.payload, ...payToData };
          this.bankDetailsError = '';
        });
    },
    async submit() {
      this.$v.$touch();
      this.bankDetailsError = '';

      if (!this.payload.accountNumber) {
        this.bankDetailsError = 'Bank Details is required.';
        return;
      }
      if (this.$v.$error) {
        return;
      }

      await this.createClaim({
        payload: this.payload,
        files: this.files
      });
      this.submitted = true;
    },
    restart() {
      this.files = [];
      this.payload = { ...CREATE_BASE_PAYLOAD };
      this.$v.$reset();
      this.submitted = false;
      this.bankDetailsError = '';
    },
    close() {
      this.$router.push({
        name: this.$RouteNames.claims
      });
    }
  },
  async beforeMount() {
    this.restart();
    this.images = {
      ...this.images,
      claimSubmitted: await getAsset(this.$Constants.CLAIM_SUBMITTED_IMG_PATH)
    };
  },
  mounted() {
    if (!this.hasLeases || !this.leases.length) {
      return this.$router.push({
        name: this.$RouteNames.dashboard
      });
    }

    if (this.leases.length === 1) {
      this.payload = { ...this.payload, leaseId: this.leases[0].id };
    }
  },
  components: {
    ClaimsNew: () => import('../../components/page/claims-new')
  }
};
</script>
